import { Icon } from "@chakra-ui/react";
import React from "react";

const CompactPluginIcon = (props) => (
  <Icon viewBox="0 0 40 40" fill="none" {...props}>
    <rect x="25" y="6" width="9" height="9" rx="2" stroke="currentColor" stroke-width="2" />
  </Icon>
);

export default React.memo(CompactPluginIcon);
